/** Tema fijo claro — sin modo oscuro ni preferencia del sistema. */
export type ThemeMode = 'light';

const LS_KEY = 'toscana.theme.v1';

export const theme = {
  get value(): ThemeMode { return 'light'; },
};

export function applyTheme(): void {
  if (typeof document === 'undefined') return;
  document.documentElement.setAttribute('data-theme', 'light');
  try {
    localStorage.setItem(LS_KEY, 'light');
  } catch { /* ignore */ }
}

applyTheme();
